export default __webpack_public_path__ + "static/howitworks2-296af4b3dd836a9f90796361c80d7269.svg";